<script>
  import { Tabs } from "../../components/index.svelte";
  import { translator } from "../../store";
  import MaintenanceTable from "../Properties/Maintenance/MaintenanceTable.svelte";
</script>
<Tabs configuration={{
  cleaning: {
    tabTitle: translator('Temizlik Giderleri'),
    component: MaintenanceTable,
    componentProps: {
      allProperties: true,
      filter: 'cleaning'
    }
  },
  notCleaning: {
    tabTitle: translator('Diğer Giderler'),
    component: MaintenanceTable,
    componentProps: {
      allProperties: true,
      filter: 'not-cleaning'
    }
  }
}}/>
